import React from "react";

import { NEW_BRAND_ICON_MD } from "src/helpers";

type Props = {};

const BrandComponent = (props: Props) => {
  return (
    <div>
      <div className="hidden md:block" style={{ height: "65px" }}>
        <img
          src={NEW_BRAND_ICON_MD}
          style={{ width: "100%", height: "100%", display: "block" }}
          alt="NEW_BRAND_ICON_MD"
        />
      </div>
      <div className="hidden max-md:block" style={{ height: "48px" }}>
        <img
          src={NEW_BRAND_ICON_MD}
          style={{ width: "100%", height: "100%", display: "block" }}
          alt="NEW_BRAND_ICON_MD"
        />
      </div>
    </div>
  );
};

export default BrandComponent;
